module.exports = {"610830100":"宽州镇","610830101":"石咀驿镇","610830102":"折家坪镇","610830103":"玉家河镇","610830104":"高杰村镇","610830105":"李家塔镇","610830106":"店则沟镇","610830107":"解家沟镇","610830108":"下廿里铺镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610830.json
// module id = 3008
// module chunks = 0